import React, { useEffect, useRef, useState } from "react";
import UploadedFile from "../../forms/additionalinformation/UploadedFile";
import { useTranslation } from "react-i18next";
import {
  GetAdditionalUploadedDocs,
  setLoadingState,
  uploadFiles,
  uploadFileToMemory,
} from "../../../features/uploadDocument/uploadDocumentSlice";
import { useDispatch, useSelector } from "react-redux";
import { authLoginSelector } from "../../../features/auth/authLoginSlice";
import { orderLawyerInfoSelector } from "../../../features/auth/orderLawyerInformationSlice";
import DragAndDrop from "../DragAndDrop/DragAndDrop";
import {
  UploadDocumentAcceptedTypesStringConstants,
  UploadDocumentTypesArrayConstansts,
} from "../../../common/constants";
import { toast } from "react-toastify";
import { logUnAcceptedFiles } from "../../../common/utils";

const UploadDragDocument = ({
  fieldName,
  formApiName,
  control,
  Controller,
  trigger,
  setValue,
  inline = false,
  documentName = "",
  sectionName,
  propertyDependent = false,
  documentType = "",
  propertyId = "",
  fileproblemId = "",
  isSingleDoc = false,
  isDeleteDialogRequired = false,
  isSubmitButtonRequired = false,
  additionalDocumentsArray,
  values,
  propertyList,
  propertyNumber,
  isAdditionalDocumentScreen,
  hasValue,
  requiredDocument,
  setHasValue,
  summaryPage,
  propertyArray,
  reset,
  documentTypeArray,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userLogin } = useSelector(authLoginSelector);
  const { postOrderDetailsInfo } = useSelector(orderLawyerInfoSelector);
  const [additionalDocArray, setAdditionalDocArray] = useState([]);
  const fileUpload = useRef(null);

  const handleButtonClick = () => {
    fileUpload.current.click();
  };

  const formRequestToUpload = (name, val, field, propertyId, documentType) => {
    let req = {};
    req.FileID = postOrderDetailsInfo?.fileID;
    req.DocumentFileName = val[0]?.name;
    req.UserID = userLogin?.userId;
    req.IsPublic = true;
    req.DocumentType = documentType || "Other";
    req.propertyID = propertyId || 0;
    req.SectionName = sectionName;
    req.FileNumber = postOrderDetailsInfo?.fileNumber;
    req.Notes = "";
    req.DocStoreId = 1;
    req.fileproblemId = fileproblemId || 0;
    return req;
  };

  useEffect(() => {
    if (propertyDependent) {
      const updatedArray = additionalDocArray?.map((doc) => ({
        ...doc,
        propertyId: propertyId,
        documentType: documentType,
      }));
      setAdditionalDocArray(updatedArray);
    }
  }, [propertyId, documentType]);

  async function changeFieldThisOrder(name, val, field) {
    if (propertyDependent && !propertyId && !documentType) {
      return;
    }
    //upload file API call
    if (field) {
      if (propertyDependent) {
        setAdditionalDocArray((prevArray) => [
          ...prevArray,
          {
            name: name,
            val: val,
            field: field,
            propertyId: propertyId,
            documentType: documentType,
          },
        ]);
      }
      if (isSingleDoc || propertyDependent) {
        dispatch(
          uploadFileToMemory(
            val[0],
            val[0]?.name,
            fieldName,
            propertyDependent,
            {
              setValue,
              trigger,
              field,
            },
          ),
        );
      } else {
        let req = formRequestToUpload(
          name,
          val,
          field,
          propertyId,
          documentType,
        );
        dispatch(
          uploadFiles(
            req,
            val[0]?.name,
            fieldName,
            val,
            {
              setValue,
              trigger,
              field,
            },
            isSingleDoc,
          ),
        );
      }
    }
  }

  async function SubmitDocuments(name, val, field) {
    let req = formRequestToUpload(name, val, field, propertyId, documentType);
    dispatch(
      uploadFiles(
        req,
        val[0]?.name,
        fieldName,
        val,
        {
          setValue,
          trigger,
          field,
        },
        isSingleDoc,
      ),
    );
    dispatch(
      uploadFileToMemory(
        val[0],
        val[0]?.name,
        fieldName,
        propertyDependent,
        {
          setValue,
          trigger,
          field,
        },
        isSingleDoc,
      ),
    );
    setHasValue && setHasValue(false);
    if (fileUpload.current) {
      fileUpload.current.value = "";
    }
  }

  const SubmitAdditionalDocuments = () => {
    if (fileUpload.current) {
      fileUpload.current.value = "";
    }
    reset();
    additionalDocArray?.forEach((docs, index) => {
      let req = formRequestToUpload(
        docs?.name,
        docs?.val,
        docs?.field,
        propertyArray?.length === 1
          ? -1
          : docs?.propertyId == 1
            ? -1
            : docs?.propertyId,
        (documentTypeArray &&
          documentTypeArray?.length > 0 &&
          documentTypeArray?.find((item) => item.value === docs?.documentType)
            ?.value) ||
          "",
      );
      let field = docs?.field;
      dispatch(
        uploadFiles(
          req,
          docs?.val[0]?.name,
          fieldName,
          docs?.val,
          {
            setValue,
            trigger,
            field,
          },
          isSingleDoc,
        ),
      );
      setAdditionalDocArray([]);
      setHasValue && setHasValue(false);
      dispatch(
        uploadFileToMemory(
          [],
          [],
          fieldName,
          propertyDependent,
          {
            setValue,
            trigger,
            field,
          },
          isSingleDoc,
        ),
      );
    });
  };

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        defaultValue={null}
        render={({ field }, index) => {
          return (
            <>
              <input
                type="file"
                ref={fileUpload}
                onChange={(e) => {
                  const acceptedFilesUnfiltered = [...e.target.files];
                  const acceptedFiles = acceptedFilesUnfiltered.filter(
                    ({ type }) =>
                      UploadDocumentTypesArrayConstansts?.includes(type),
                  );
                  // Log unsupported file types
                  logUnAcceptedFiles(acceptedFilesUnfiltered, { toast }, t);
                  changeFieldThisOrder(fieldName, [...acceptedFiles], field);
                  setHasValue && acceptedFiles?.length > 0 && setHasValue(true);
                }}
                accept={UploadDocumentAcceptedTypesStringConstants}
                multiple
                style={{ display: "none" }}
              />
              {inline ? (
                <div className="flex items-center justify-between">
                  <div className="custom__add-section self-end">
                    <div className="custom__add-section">
                      <div className="flex flex-col pr-4">
                        <div className="w-[733px] absolute mr-4 h-[125px] top-[-25px] left-[-30px] opacity-40 hover:bg-[#FFFAEB] hover:border hover:border-primary-yellow rounded"></div>
                        <div
                          className={`font-semibold ${
                            field?.value?.length === 0
                              ? "text-secondary-red"
                              : "text-secondary-black"
                          } flex mb-2`}
                        >
                          {field?.value?.length === 0 && (
                            <img
                              src="../../images/alert-circle.cd312933.svg"
                              aria-hidden="true"
                              className="mr-2"
                              alt="alert icon"
                            />
                          )}

                          {documentName}
                        </div>
                        <DragAndDrop
                          onDrop={(acceptedFiles) => {
                            const pdfFiles = acceptedFiles.filter(({ type }) =>
                              UploadDocumentTypesArrayConstansts?.includes(
                                type,
                              ),
                            );
                            // Log unsupported file types
                            logUnAcceptedFiles(acceptedFiles, { toast }, t);
                            changeFieldThisOrder(
                              fieldName,
                              [...pdfFiles],
                              field,
                            );
                          }}
                          name={fieldName}
                          t={t}
                          inline
                        />
                      </div>
                    </div>
                  </div>

                  <div className="custom__upload-file">
                    <button
                      type="button"
                      className="btn__icon-file"
                      onClick={handleButtonClick}
                      disabled={
                        requiredDocument
                          ? !hasValue
                            ? false
                            : field?.value?.length === 0
                              ? true
                              : false
                          : false
                      }
                    >
                      <span>{t("uploadDocument")}</span>
                      <svg
                        aria-hidden="true"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <line
                          x1="4"
                          y1="10.6816"
                          x2="16"
                          y2="10.6816"
                          stroke="#231F20"
                          strokeWidth="2"
                          strokeLinecap="round"
                        ></line>
                        <line
                          x1="10"
                          y1="4.5"
                          x2="10"
                          y2="16.5"
                          stroke="#231F20"
                          strokeWidth="2"
                          strokeLinecap="round"
                        ></line>
                      </svg>
                    </button>
                    <input
                      className="hidden"
                      id="file_input4"
                      type="file"
                      aria-label="Upload Document"
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="custom__upload-file float-right mt_-40">
                    <button
                      type="button"
                      className="btn__icon-file"
                      onClick={handleButtonClick}
                      disabled={
                        propertyDependent
                          ? propertyArray?.length > 1
                            ? !(propertyId && documentType) ||
                              documentType == 0 ||
                              propertyId == 0
                            : !documentType || documentType == 0
                          : false
                      }
                    >
                      <span>{t("uploadDocument")}</span>
                      <svg
                        aria-hidden="true"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <line
                          x1="4"
                          y1="10.6816"
                          x2="16"
                          y2="10.6816"
                          stroke="#231F20"
                          strokeWidth="2"
                          strokeLinecap="round"
                        ></line>
                        <line
                          x1="10"
                          y1="4.5"
                          x2="10"
                          y2="16.5"
                          stroke="#231F20"
                          strokeWidth="2"
                          strokeLinecap="round"
                        ></line>
                      </svg>
                    </button>
                  </div>
                  <DragAndDrop
                    onDrop={(acceptedFiles) => {
                      const pdfFiles = acceptedFiles.filter(({ type }) =>
                        UploadDocumentTypesArrayConstansts?.includes(type),
                      );
                      // Log unsupported file types
                      logUnAcceptedFiles(acceptedFiles, { toast }, t);
                      changeFieldThisOrder(fieldName, [...pdfFiles], field);
                    }}
                    name={fieldName}
                    t={t}
                    isAllowFullDrag
                    disabled={
                      propertyDependent
                        ? propertyArray?.length > 1
                          ? !(propertyId && documentType) ||
                            documentType == 0 ||
                            propertyId == 0
                          : !documentType || documentType == 0
                        : false
                    }
                  />
                </>
              )}
              {summaryPage
                ? additionalDocArray?.length > 0 &&
                  field?.value &&
                  field?.value?.length > 0 &&
                  field?.value?.map((item, index) => (
                    <UploadedFile
                      name={item.name}
                      docName={documentName}
                      t={t}
                      index={index}
                      popFile={(name) => {
                        field.onChange(
                          field.value.filter((it) => it.name !== name),
                        );
                        changeFieldThisOrder(fieldName, [
                          ...field.value.filter((it) => it.name !== name),
                        ]);
                        if (fileUpload.current) {
                          fileUpload.current.value = "";
                        }
                        setAdditionalDocArray(
                          additionalDocArray?.filter(
                            (doc) => doc.val[0]?.name !== name,
                          ),
                        );
                        setHasValue && setHasValue(false);
                      }}
                      file={item}
                      title=""
                      isDeleteDialogRequired={isDeleteDialogRequired}
                      isSubmitButtonRequired={isSubmitButtonRequired}
                      SubmitDocuments={SubmitDocuments}
                      field={field}
                      value={[...field.value.filter((it) => it.name !== name)]}
                      additionalDocArray={additionalDocArray}
                      propertyList={propertyList}
                      propertyNumber={propertyNumber}
                      setAdditionalDocArray={setAdditionalDocArray}
                      isAdditionalDocumentScreen={isAdditionalDocumentScreen}
                      documentType={additionalDocArray.map((doc) => {
                        const matchedType = documentTypeArray.find(
                          (type) => type.value === doc.documentType,
                        );

                        return matchedType?.label;
                      })}
                      propertyId={propertyId}
                      summaryPage={summaryPage}
                    />
                  ))
                : field?.value &&
                  field?.value?.length > 0 &&
                  field?.value?.map((item, index) => (
                    <UploadedFile
                      name={item.name}
                      docName={documentName}
                      t={t}
                      index={index}
                      popFile={(name) => {
                        field.onChange(
                          field.value.filter((it) => it.name !== name),
                        );
                        changeFieldThisOrder(fieldName, [
                          ...field.value.filter((it) => it.name !== name),
                        ]);
                        if (fileUpload.current) {
                          fileUpload.current.value = "";
                        }
                        setHasValue && setHasValue(false);
                      }}
                      file={item}
                      title=""
                      isDeleteDialogRequired={isDeleteDialogRequired}
                      isSubmitButtonRequired={isSubmitButtonRequired}
                      SubmitDocuments={SubmitDocuments}
                      field={field}
                      value={[...field.value.filter((it) => it.name !== name)]}
                      additionalDocArray={additionalDocArray}
                      propertyList={propertyList}
                      propertyNumber={propertyNumber}
                      setAdditionalDocArray={setAdditionalDocArray}
                      isAdditionalDocumentScreen={isAdditionalDocumentScreen}
                      documentType={additionalDocArray.map((doc) => {
                        const matchedType = documentTypeArray.find(
                          (type) => type.value === doc.documentType,
                        );

                        return matchedType?.label;
                      })}
                      propertyId={propertyId}
                      summaryPage={summaryPage}
                    />
                  ))}
            </>
          );
        }}
      />
      {(summaryPage || isAdditionalDocumentScreen) &&
        additionalDocArray?.length > 0 && (
          <div
            className={`flex flex-col ${
              isAdditionalDocumentScreen ? "pt-4" : "pt-1"
            }`}
          >
            <button
              type="button"
              className="btn__primary flex w-[200px] py-[10px]"
              onClick={() => SubmitAdditionalDocuments()}
              disabled={additionalDocArray?.length === 0}
            >
              {t("SubmitDocuments")}
            </button>
          </div>
        )}
    </>
  );
};

export default UploadDragDocument;
